export const OBTAIN_TOKENS = 'OBTAIN_TOKENS'
export const INSPECT_TOKENS = 'INSPECT_TOKENS'
export const FETCH_USER_DATA = 'FETCH_USER_DATA'
export const REFRESH_TOKENS = 'REFRESH_TOKENS'
export const DESTROY_SESSION = 'DESTROY_SESSION'
export const PASSWORD_CHALLENGE = 'PASSWORD_CHALLENGE'
export const UPDATE_ACCOUNT_DATA = 'UPDATE_ACCOUNT_DATA'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const SET_DEPARTMENT = 'SET_DEPARTMENT'
export const SET_SHIPPING_RULES = 'SET_SHIPPING_RULES'
export const REQUEST_NEW_PASSWORD = 'REQUEST_NEW_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const CHANGE_DEFAULT_DEPARTMENT = 'CHANGE_DEFAULT_DEPARTMENT'
export const FETCH_MFA_STATUS = 'FETCH_MFA_STATUS'
export const MFA_ASSOCIATE = 'MFA_ASSOCIATE'
export const MFA_VERIFY = 'MFA_VERIFY'
export const MFA_CHALLENGE = 'MFA_CHALLENGE'
export const MFA_DISABLE = 'MFA_DISABLE'

